import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { getText, TEXT_KEY } from '../../utils/localization';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
var GenericMessage = /*#__PURE__*/function (_Component) {
  function GenericMessage() {
    _classCallCheck(this, GenericMessage);
    return _callSuper(this, GenericMessage, arguments);
  }
  _inherits(GenericMessage, _Component);
  return _createClass(GenericMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var pendingMessage = this.props.pendingMessage;
      if (!pendingMessage) {
        QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
        return;
      }
      if (pendingMessage.type === 'BONUS_LINK') {
        if (pendingMessage.success) {
          this.setState({
            title: getText(TEXT_KEY.CONGRATULATIONS),
            message: pendingMessage.msg
          });
        } else {
          this.setState({
            title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
            message: pendingMessage.error
          });
        }
      } else if (pendingMessage.type === 'PROMO_LINK') {
        return;
      }
      this.props.shiftPendingMessage();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.render(_objectSpread(_objectSpread({}, this.state), this.props));
    }
  }]);
}(Component);
export { GenericMessage as default };